var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotoStudentLightSkinTone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.7656 62.3125C76.7891 60.5391 78.0313 58.7344 80.1562 56.5C83.5234 52.9531 87.1875 44.7266 83.7812 36.375C83.8047 36.3281 83.1094 34.9219 83.1328 34.875L81.7344 34.8047C81.2891 34.7422 65.9063 34.7109 50.5078 34.7109C35.1094 34.7109 19.7266 34.7422 19.2812 34.8047C19.2812 34.8047 17.2109 36.3281 17.2266 36.375C13.8281 44.7266 17.4844 52.9531 20.8516 56.5C22.9687 58.7344 24.2109 60.5391 23.2422 62.3125C22.2969 64.0391 19.4844 64.2891 19.4844 64.2891C19.4844 64.2891 20.1328 66.0547 21.6953 67.0078C23.1406 67.8906 24.9219 68.0937 26.1484 68.125C26.1484 68.125 30.9531 74.7734 43.5156 74.7734H57.5C70.0625 74.7734 74.8672 68.125 74.8672 68.125C76.0938 68.0937 77.875 67.8906 79.3203 67.0078C80.8828 66.0547 81.5313 64.2891 81.5313 64.2891C81.5313 64.2891 78.7109 64.0313 77.7656 62.3125Z",
    fill: "#312D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4922 74.7656V67.3906L72.8125 65.625L74.8438 68.125C74.8438 68.125 70.0391 74.7734 57.4766 74.7734L50.4922 74.7656Z",
    fill: "url(#paint0_radial_10_7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7969 64.8984C71.4531 59.8203 78.8672 57.9219 78.8672 57.9219L78.875 57.9297C77.5859 59.5313 77 60.9297 77.7578 62.3125C78.7031 64.0391 81.5156 64.2891 81.5156 64.2891C81.5156 64.2891 77.6797 67.6953 74.7969 64.8984Z",
    fill: "url(#paint1_radial_10_7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7969 36.375C87.1172 44.4609 83.625 52.7891 80.3516 56.3047C79.9063 56.7891 78 58.6562 77.5625 60.1484C77.5625 60.1484 70.1094 49.75 67.8828 43.6406C67.4375 42.4062 67.0234 41.1406 66.9688 39.8281C66.9297 38.8437 67.0781 37.6719 67.6484 36.8359C68.3437 35.8125 83.3984 35.5078 83.3984 35.5078C83.3984 35.5156 83.7969 36.375 83.7969 36.375Z",
    fill: "url(#paint2_radial_10_7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2187 36.375C13.8984 44.4609 17.3906 52.7891 20.6641 56.3047C21.1172 56.7891 23.0156 58.6562 23.4531 60.1484C23.4531 60.1484 30.9062 49.75 33.1328 43.6406C33.5859 42.4062 33.9922 41.1406 34.0469 39.8281C34.0859 38.8437 33.9375 37.6719 33.3672 36.8359C32.6719 35.8125 31.8594 36.0859 30.6797 36.0859C28.4297 36.0859 18.5781 35.5078 17.8125 35.5078C17.8203 35.5156 17.2187 36.375 17.2187 36.375Z",
    fill: "url(#paint3_radial_10_7)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5234 74.7656V67.3906L28.2031 65.625L26.1719 68.125C26.1719 68.125 30.9766 74.7734 43.5391 74.7734L50.5234 74.7656Z",
    fill: "url(#paint4_radial_10_7)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2187 64.8984C29.5625 59.8203 22.1484 57.9219 22.1484 57.9219L22.1406 57.9297C23.4297 59.5313 24.0156 60.9297 23.2578 62.3125C22.3125 64.0391 19.5 64.2891 19.5 64.2891C19.5 64.2891 23.3359 67.6953 26.2187 64.8984Z",
    fill: "url(#paint5_radial_10_7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1406 87.5312V69.7266H42.8516V87.5312H58.1406ZM71.8516 39.3281H29.1484C24.5469 39.3281 20.7812 43.3359 20.7812 48.2422C20.7812 53.1484 24.5469 57.1563 29.1484 57.1563H71.8438C76.4453 57.1563 80.2109 53.1406 80.2109 48.2422C80.2188 43.3438 76.4531 39.3281 71.8516 39.3281Z",
    fill: "#EDC391"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 8.57812C36.9063 8.57812 24.3125 23.1172 24.3125 44.0469C24.3125 64.8594 37.2891 75.1484 50.5 75.1484C63.7109 75.1484 76.6875 64.8594 76.6875 44.0469C76.6875 23.1172 64.0938 8.57812 50.5 8.57812Z",
    fill: "#F9DDBD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3125 38.8438C42.5859 37.8828 40.9141 36.4922 37.6641 36.4922C34.4141 36.4922 32.7344 37.8906 32.0156 38.8438C31.6953 39.2656 31.7734 39.7578 32 40.0547C32.2031 40.3281 32.8125 40.5859 33.4844 40.3594C34.1562 40.1328 35.4687 39.4531 37.6641 39.4375C39.8594 39.4531 41.1719 40.1328 41.8437 40.3594C42.5156 40.5859 43.125 40.3359 43.3281 40.0547C43.5469 39.7656 43.6328 39.2734 43.3125 38.8438ZM68.9922 38.8438C68.2656 37.8828 66.5937 36.4922 63.3437 36.4922C60.0937 36.4922 58.4141 37.8906 57.6953 38.8438C57.375 39.2656 57.4531 39.7578 57.6797 40.0547C57.8828 40.3281 58.4922 40.5859 59.1641 40.3594C59.8359 40.1328 61.1484 39.4531 63.3437 39.4375C65.5391 39.4531 66.8516 40.1328 67.5234 40.3594C68.1953 40.5859 68.8047 40.3359 69.0078 40.0547C69.2266 39.7656 69.3125 39.2734 68.9922 38.8438Z",
    fill: "#454140"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6563 49.8594C39.7834 49.8594 41.5078 48.0755 41.5078 45.875C41.5078 43.6745 39.7834 41.8906 37.6563 41.8906C35.5291 41.8906 33.8047 43.6745 33.8047 45.875C33.8047 48.0755 35.5291 49.8594 37.6563 49.8594Z",
    fill: "#312D2D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3438 49.8594C65.4709 49.8594 67.1953 48.0755 67.1953 45.875C67.1953 43.6745 65.4709 41.8906 63.3438 41.8906C61.2166 41.8906 59.4922 43.6745 59.4922 45.875C59.4922 48.0755 61.2166 49.8594 63.3438 49.8594Z",
    fill: "#312D2D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0781 59.4141C54.5938 60.8907 46.4297 60.8907 43.9453 59.4141C42.5156 58.5625 41.0547 59.8672 41.6484 61.1641C42.2344 62.4375 46.6797 65.3985 50.5313 65.3985C54.3828 65.3985 58.7734 62.4375 59.3594 61.1641C59.9453 59.8672 58.5078 58.5625 57.0781 59.4141Z",
    fill: "#444444"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5156 53.0938C53.4297 53.0625 53.3516 53.0391 53.2656 53.0312H47.7344C47.6484 53.0391 47.5625 53.0625 47.4844 53.0938C46.9844 53.2969 46.7109 53.8125 46.9453 54.3672C47.1797 54.9219 48.2813 56.4688 50.5 56.4688C52.7188 56.4688 53.8203 54.9141 54.0547 54.3672C54.2891 53.8203 54.0156 53.2969 53.5156 53.0938Z",
    fill: "#DBA689"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0547 18.3203C77.4375 14.6328 67.2344 8.07025 63.4141 6.85932C53.0703 3.58588 46.3438 4.914 42.7344 6.88275C41.9844 7.289 37.1328 9.98432 33.7422 8.05463C31.6172 6.84369 25.5156 16.5234 22.4453 18.3749C18.8594 20.539 19.1719 24.4765 19.7188 26.0078C17.75 27.6796 15.2734 31.2343 16.9688 35.8515C18.25 39.3281 23.3516 40.9296 23.3516 40.9296C22.8672 49.3203 25.1328 53.3906 25.1328 53.3906C25.1328 53.3906 28.7969 38.9765 28.4922 36.7734C28.4922 36.7734 34.5547 35.5703 41.4375 31.6328C46.0859 28.9687 49.2656 25.8515 54.4922 24.6718C62.4453 22.8828 64.2188 28.6406 64.2188 28.6406C64.2188 28.6406 71.5781 27.2265 73.7969 37.4453C74.7109 41.6484 75.3047 48.6171 75.8047 52.8906C75.7578 52.5156 78.3359 47.9453 78.8203 43.2578C78.9453 42.0468 82.2109 40.4453 83.6172 35.2421C85.4922 28.3046 83.4297 20.789 78.0547 18.3203Z",
    fill: "#312D2D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.625 35.2344C82.4531 39.5547 80.0078 41.3906 79.1328 42.5859C77.9297 35.2656 78.1172 28.3125 69.2031 20.0781C69.2031 20.0781 70.9922 19.6953 71.8672 18.1016C72.5469 16.8594 72.2891 15.3125 72.2891 15.3125C72.5859 15.3281 72.8906 15.3594 73.2031 15.3984C74.7344 15.6797 76.2969 16.4297 77.7266 17.3906C77.8984 17.7187 78.0078 18.0313 78.0547 18.3203C83.4297 20.7813 85.5 28.2969 83.625 35.2344Z",
    fill: "url(#paint6_radial_10_7)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5391 26.1641C17.6875 27.8047 15.1953 31.4687 17.0312 36.0156C18.4141 39.4453 23.3516 40.9297 23.3516 40.9297C23.3516 40.9453 24.3359 41.2422 24.8437 41.2422L26 24.1328C23.6328 24.1328 21.3594 24.8438 19.8906 25.8672C19.9141 25.8906 19.5312 26.1406 19.5391 26.1641Z",
    fill: "url(#paint7_radial_10_7)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0391 24.1406V24.1016C23.6719 24.1016 21.4062 24.8125 19.9297 25.8281C19.9297 25.8516 19.8125 25.9375 19.7187 26.0078V26C19.7266 25.9922 19.7422 25.9844 19.75 25.9766C19.2031 24.4453 18.8828 20.5078 22.4766 18.3437C22.8203 18.1328 23.2031 17.8281 23.6172 17.4453C24.5703 17.0547 25.5859 16.8281 26.5234 16.7344C26.7969 16.7109 27.2969 16.6719 27.4453 16.6719L31.2031 17.1328L26.0391 24.1406Z",
    fill: "url(#paint8_radial_10_7)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6484 41.6406C90.6797 41.6406 89.8906 42.3906 89.8906 43.3125V50.5C89.8906 51.4219 90.6797 52.1719 91.6484 52.1719C92.6172 52.1719 93.4062 51.4219 93.4062 50.5V43.3125C93.4062 42.3906 92.6172 41.6406 91.6484 41.6406ZM88.1328 41.6406C87.1641 41.6406 86.375 42.3906 86.375 43.3125V50.5C86.375 51.4219 87.1641 52.1719 88.1328 52.1719C89.1016 52.1719 89.8906 51.4219 89.8906 50.5V43.3125C89.8906 42.3906 89.1016 41.6406 88.1328 41.6406Z",
    fill: "#E8AD00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8906 41.6406C88.9219 41.6406 88.1328 42.3906 88.1328 43.3125V52.0547C88.1328 52.9766 88.9219 53.7266 89.8906 53.7266C90.8594 53.7266 91.6484 52.9766 91.6484 52.0547V43.3125C91.6484 42.3906 90.8594 41.6406 89.8906 41.6406Z",
    fill: "#FFCA28"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8906 42.7344C91.0815 42.7344 92.0469 41.8145 92.0469 40.6797C92.0469 39.5449 91.0815 38.625 89.8906 38.625C88.6998 38.625 87.7344 39.5449 87.7344 40.6797C87.7344 41.8145 88.6998 42.7344 89.8906 42.7344Z",
    fill: "#FFCA28"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8906 40.6562C89.4609 40.6562 89.1094 40.3047 89.1094 39.875V10.1875C89.1094 9.75781 89.4609 9.40625 89.8906 9.40625C90.3203 9.40625 90.6719 9.75781 90.6719 10.1875V39.875C90.6719 40.3047 90.3203 40.6562 89.8906 40.6562Z",
    fill: "#504F4F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6719 9.375C66.5859 3.32031 50.0469 3.125 50.0469 3.125C50.0469 3.125 33.5078 3.32031 9.42188 9.375V9.97656C9.42188 11.0156 10.1016 11.9297 11.0938 12.2188C14 13.0781 20.0547 14.8281 24.0078 15.625C24.0078 15.625 23.1406 16.9609 22.4453 18.375C22.4453 18.375 30.2188 23 50.0469 25C69.875 23 78.0547 18.3203 78.0547 18.3203C77.3672 16.9063 76.5078 15.625 76.5078 15.625C80.0234 15.0469 86.1328 13.1719 89.0391 12.25C90.0156 11.9375 90.6719 11.0391 90.6719 10.0156V9.375Z",
    fill: "url(#paint9_linear_10_7)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0469 3.125C50.0469 3.125 33.5078 3.32031 9.42188 9.375C9.42188 9.375 37.0859 16.9297 50.0469 16.7031C63.0078 16.9297 90.6719 9.375 90.6719 9.375C66.5781 3.32031 50.0469 3.125 50.0469 3.125Z",
    fill: "url(#paint10_linear_10_7)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M90.6719 9.375C66.5859 3.32031 50.0469 3.125 50.0469 3.125C50.0469 3.125 33.5078 3.32031 9.42188 9.375V9.97656C9.42188 11.0156 10.1016 11.9297 11.0938 12.2188C14 13.0781 20.0547 14.8281 24.0078 15.625C24.0078 15.625 23.1406 16.9609 22.4453 18.375C22.4453 18.375 30.2188 23 50.0469 25C69.875 23 78.0547 18.3203 78.0547 18.3203C77.3672 16.9063 76.5078 15.625 76.5078 15.625C80.0234 15.0469 86.1328 13.1719 89.0391 12.25C90.0156 11.9375 90.6719 11.0391 90.6719 10.0156V9.375Z",
    fill: "url(#paint11_linear_10_7)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9531 94.5234C89.9531 83.1094 72.9609 77.6953 58.1406 76.4766L51.4219 85.0937C51.2031 85.375 50.8594 85.5469 50.5 85.5469C50.1406 85.5469 49.7969 85.3828 49.5781 85.0937L42.8438 76.4609C34.6016 77.0938 11.0391 80.1719 11.0391 94.5234V96.875H89.9453L89.9531 94.5234Z",
    fill: "#212121"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9531 94.5234C89.9531 83.1094 72.9609 77.6953 58.1406 76.4766L51.4219 85.0937C51.2031 85.375 50.8594 85.5469 50.5 85.5469C50.1406 85.5469 49.7969 85.3828 49.5781 85.0937L42.8438 76.4609C34.6016 77.0938 11.0391 80.1719 11.0391 94.5234V96.875H89.9453L89.9531 94.5234Z",
    fill: "url(#paint12_radial_10_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.893 64.108) scale(18.2961 8.98704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.915 61.3862) rotate(154.924) scale(5.40676 4.01104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#454140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.9025 46.0935) rotate(-94.2783) scale(23.7489 19.7932)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_10_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.1156 46.0931) rotate(-85.7217) scale(23.7489 19.7932)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1242 64.108) rotate(180) scale(18.2961 8.98704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_10_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1043 61.3867) rotate(25.0761) scale(5.40676 4.01104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#454140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_10_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.2428 33.9544) rotate(72.0851) scale(26.4652 19.6366)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_10_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.606 33.8275) rotate(7.83355) scale(13.1926 18.5378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_10_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4725 25.1747) rotate(-164.942) scale(10.1105 9.46162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10_7",
    x1: 50.0445,
    y1: -0.260156,
    x2: 50.0445,
    y2: 22.1148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10_7",
    x1: 50.0445,
    y1: -0.130468,
    x2: 50.0445,
    y2: 24.0883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10_7",
    x1: 10.8977,
    y1: 14.0617,
    x2: 89.6695,
    y2: 14.0617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#BFBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#212121",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#212121",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBEBE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_10_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5 95.7837) scale(42.318 22.2042)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616161"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoStudentLightSkinTone);
export default __webpack_public_path__ + "static/media/noto_student-light-skin-tone.7c0238883b2f07e243656036758a123a.svg";
export { ForwardRef as ReactComponent };